// Demo mode detection and lifecycle
// Gated behind REACT_APP_ENABLE_DEMO env var for security

const DEMO_STORAGE_KEY = 'flowstock.demo';

function isDemoEnabled(): boolean {
  return process.env.REACT_APP_ENABLE_DEMO === 'true';
}

export function isDemoMode(): boolean {
  if (!isDemoEnabled()) return false;
  if (typeof window === 'undefined') return false;

  // Check sessionStorage
  try {
    if (sessionStorage.getItem(DEMO_STORAGE_KEY) === 'true') return true;
  } catch {}

  // Check URL param and auto-activate
  try {
    if (new URLSearchParams(window.location.search).has('demo')) {
      sessionStorage.setItem(DEMO_STORAGE_KEY, 'true');
      return true;
    }
  } catch {}

  return false;
}

export function activateDemo(): void {
  if (!isDemoEnabled()) return;
  try {
    sessionStorage.setItem(DEMO_STORAGE_KEY, 'true');
  } catch {}
}

export function deactivateDemo(): void {
  try {
    sessionStorage.removeItem(DEMO_STORAGE_KEY);
  } catch {}
  window.location.replace('/');
}
